// src/components/ProtectedRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";

export default function ProtectedRoute() {
  const { user } = useAuthenticator((context) => [context.user]);

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
